import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'positiveOutcomes',
    label: 'Positive Outcomes',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
